export default __webpack_public_path__ + "static/media/safe.f98753e1.png";